import CriticalErrorHandler from './CriticalErrorHandler';

export default CriticalErrorHandler;
